import React, { Component } from "react";

import axios from "../../../axios";

import {
    MDBRow,
    MDBCol,
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
    toast,
} from "mdbreact";

import MessagesData from "../../../components/SubscriberMgmt/Messages/Datatables/MessagesData";

import parse from "html-react-parser";

import { withTranslation } from "react-i18next";

class MessagesModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalMessage: false,
            modalMessageData: false,
        };
    }

    toggleMessage = (key) => {
        this.setState({
            modalMessage: !this.state.modalMessage,
            messageID: key,
        });
    };

    toggleModalMessageData = () => {
        this.setState({
            modalMessageData: !this.state.modalMessageData,
        });
    };

    toggle = () => {
        this.setState({
            modalMessage: !this.state.modalMessage,
        });
    };
    submitConfirmMessage = (index) => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            MessageID: index,
        };
        axios
            .post("/subscriberconsole/acknowledgeMessageFromVenue", body, {
                headers: {},
            })
            .then((response) => {
                toast.success("Message Read!", {
                    closeButton: false,
                });
                this.props.listKeys();
                this.setState({
                    modalMessage: !this.state.modalMessage,
                });
            })
            .catch((error) => {
                this.setState({ error: true });
            });
    };

    render() {
        const { t } = this.props;
        return (
            <>
                <MDBModalHeader toggle={this.props.toggleModalMessageData}>
                    {t("messages.title")}
                </MDBModalHeader>
                <MDBModalBody>
                    <MessagesData
                        messages={this.props.messages}
                        toggleMessage={this.toggleMessage}
                    />
                </MDBModalBody>
                {this.state.messageID !== undefined ? (
                    <MDBModal
                        isOpen={this.state.modalMessage}
                        toggle={this.toggle}
                        centered
                    >
                        <MDBModalHeader toggle={this.toggle}>
                            {t("messages.title")}
                        </MDBModalHeader>
                        <MDBModalBody>
                            <MDBRow className="messageSubject">
                                <MDBCol>
                                    <p>{t("messages.subject")}:</p>
                                    {
                                        this.props.messages[
                                            this.state.messageID
                                        ]["Subject"]
                                    }
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol>
                                    <p>{t("messages.message")}:</p>
                                    {parse(
                                        this.props.messages[
                                            this.state.messageID
                                        ]["Message"]
                                    )}
                                </MDBCol>
                            </MDBRow>
                        </MDBModalBody>
                        <MDBModalFooter>
                            {this.props.messages[this.state.messageID][
                                "newMessage"
                            ] !== false ? (
                                <MDBBtn
                                    color="danger"
                                    onClick={(e) =>
                                        this.submitConfirmMessage(
                                            this.state.messageID
                                        )
                                    }
                                >
                                    {t("messages.acknowledge")}
                                </MDBBtn>
                            ) : (
                                ""
                            )}
                        </MDBModalFooter>
                    </MDBModal>
                ) : (
                    ""
                )}
            </>
        );
    }
}

export default withTranslation()(MessagesModal);
